import { InterestRateMethodService } from '@/modules/global-settings/loan-origination/services/other-settings/interest-rate-method.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the InterestRateMethodService class
const service = new InterestRateMethodService();
// Define the state of the module
export const state = {
  interestRateMethods: [],
  interestRateMethod: {}
};
// Define the mutations of the module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the module
export const actions = {
  /**
   * Fetches the interest rate method
   * @async
   * @param {object} commit - vuex commit
   * @returns {Object} data - interest rate method
   * @private This will set the state of the interest rate method
   */
  async getInterestRateMethod({ commit }) {
    try {
      const { data } = await service.fetchInterestRateMethod();
      commit('SET_INTEREST_RATE_METHOD', data);
      return data;
    } catch (error) {
      Logger.error('getting insurance rate method', error);
      throw error;
    }
  },

  /**
   * Fetches the interest rate methods
   * @async
   * @param {object} commit - vuex commit
   * @returns {Array} data - interest rate methods
   * @private This will set the state of the interest rate methods
   */
  async getInterestRateMethods({ commit }) {
    try {
      const { data } = await service.fetchAllInterestRateMethods();
      commit('SET_INTEREST_RATE_METHODS', data);
      return data;
    } catch (error) {
      Logger.error('getting insurance rate methods', error);
      throw error;
    }
  },

  /**
   * Creates a new interest rate method
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {object} payload - interest rate method
   * @returns {Object} data - interest rate method
   * @private This will dispatch the getInterestRateMethods action
   */
  async createInterestRateMethod({ dispatch }, payload) {
    try {
      const { data } = await service.createInterestRateMethod(payload);
      dispatch('getInterestRateMethods');
      return data;
    } catch (error) {
      Logger.error('creating insurance rate method', error);
      throw error;
    }
  },

  /**
   * Updates an interest rate method
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {number} id - id of the interest rate method
   * @param {object} payload - interest rate method
   * @returns {Object} data - interest rate method
   * @private This will dispatch the getInterestRateMethods action
   */
  async updateInterestRateMethod({ dispatch }, { id, payload }) {
    try {
      const { data } = await service.updateInterestRateMethod(id, payload);
      dispatch('getInterestRateMethods');
      return data;
    } catch (error) {
      Logger.error('updating insurance rate method', error);
      throw error;
    }
  },

  /**
   * Deletes an interest rate method
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {number} id - id of the interest rate method
   * @private This will dispatch the getInterestRateMethods action
   */
  async deleteInterestRateMethod({ dispatch }, id) {
    try {
      await service.deleteInterestRateMethod(id);
      dispatch('getInterestRateMethods');
    } catch (error) {
      Logger.error('deleting insurance rate method', error);
      throw error;
    }
  }
};
